import { render, staticRenderFns } from "./QijianHandle.vue?vue&type=template&id=fe6ecdc0&scoped=true&"
import script from "./QijianHandle.vue?vue&type=script&lang=js&"
export * from "./QijianHandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe6ecdc0",
  null
  
)

export default component.exports